import { defineMessages } from '@openedx/frontend-base';

const messages = defineMessages({
  courseInfoNotSetFallback: {
    id: 'instruct.courseInfo.generalInfo.notSetFallback',
    defaultMessage: 'Not Set',
    description: 'Fallback text used in case any of the course information is not available or provided',
  },
});

export default messages;
